import { useState } from "react";

import NavigationBar from "../../components/01_navigationBar/01_navigationBar";
import Footer from "../../components/02_footer/02_footer";

import "./05_contactPage.css";

const locations = [
    {
        name: "Mumbai - Kandivali",
        phone: "+91 08080 282 828",
        email: "mumbai.kandivali@easyhear.in",
        address:
            "53, Shubh Commercial, Opp ESIS hospital, Above Janta Restaurant & Bar, Akurli Road Kandivali East, Mumbai 400101",
        mapUrl:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9180.041282845628!2d72.85533634744371!3d19.202173710569117!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7677b6984cd%3A0x3a2e2b967e50ac79!2sEasy%20Hear%20Clinic!5e1!3m2!1sen!2sin!4v1778324774418!5m2!1sen!1sin",
    },
    {
        name: "Thane - Ghodunder Road",
        phone: "+91 08080 282 828",
        email: "thane.gbroad@easyhear.in",
        address: 
            "28, First Floor(P1), Hill Spring Commercal 1, Vijay Garden Rd, off Ghodbunder Road, Kavesar, Thane, Maharashtra 400607",
        mapUrl: 
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d605100.951188416!2d72.52393397535926!3d19.443244863984376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bb84efa53115%3A0x4ae5366735ffea17!2sEasy%20Hear%20Clinic!5e1!3m2!1sen!2sin!4v1786470229122!5m2!1sen!2sin",
    },
    {
        name: "Thane - Panchapakhadi",
        phone: "+91 08080 282 828",
        email: "thane.panchpakhadi@easyhear.in",
        address: 
            "Sarika Apartments, Next Swaroop Enclave, 2, Bhakti Mandir Rd, Bhakti Mandir, Panch Pakhdi, Thane West, Thane, Maharashtra 400602",
        mapUrl: 
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d605100.951188416!2d72.52393397535926!3d19.443244863984376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b93a78a21b69%3A0x88e7eb8ec800de67!2sEasy%20Hear%20Clinic!5e1!3m2!1sen!2sin!4v1786470186038!5m2!1sen!2sin",
    },
    {
        name: "Goa - Panjum",
        phone: "+91 08080 282 828",
        email: "goa.panjim@easyhear.in",
        address: 
            "Edcon Towers, 402, Swami Vivekanand Rd, near Fidalgo, opp. Caratlane, Ozari, Panaji, Goa 403001",
        mapUrl: 
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4830.9669640454995!2d73.82511219999999!3d15.4979363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc1f928eab297%3A0xc664877a4ee5f54!2sEasy%20Hear%20Clinic!5e1!3m2!1sen!2sin!4v1786470329166!5m2!1sen!2sin",
    },
    {
        name: "Goa - Margao",
        phone: "+91 08080 282 828",
        email: "goa.madgoan@easyhear.in",
        address: 
            "121, Hemmady Regency, near sbi bank, Malbhat, Madgaon, Goa 403601",
        mapUrl: 
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4836.2439664972435!2d73.9641224!3d15.2706005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfb3bbaf0c1539%3A0x15bf96c3621981df!2sEasy%20Hear%20Clinic!5e1!3m2!1sen!2sin!4v1786470363124!5m2!1sen!2sin",
    },
    {
        name: "Kolhapur - Rajarampuri ",
        phone: "+91 08080 282 828",
        email: "mumbaihearingclinic@gmail.com",
        address: 
            "Shop No 1, Desai Complex, 1570/E, Rajarampuri 3rd Ln, behind Indu Dreams, near Heavens Pizza, Poorvarang, Mahalaxminagar, Rajarampuri, Kolhapur, Maharashtra 416008",
        mapUrl: 
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4976.0498836770375!2d74.2414687!3d16.696572799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc101f641fd5197%3A0x20a70d94b261a3a5!2sMumbai%20Hearing%20Clinic!5e1!3m2!1sen!2sin!4v1788321196112!5m2!1sen!2sin"
    }
];

export default function Contact() {
    const [activeLocation, setActiveLocation] = useState(locations[0]);

    return (
        <div>
            <NavigationBar />

            <div className="ContactPage-Flex">

                {/* Google Maps */}
                <div className="ContactPage-iframe">
                    <iframe
                        src={activeLocation.mapUrl}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title={`${activeLocation.name} location`}
                    />
                </div>

                {/* Contact Information */}
                <div className="ContactPage-InfoSection">

                    <h2>Our Locations</h2>

                    <div className="ContactPage-InfoSection-LocationSelector">
                        {locations.map((location) => (
                            <button
                                key={location.name}
                                onClick={() => setActiveLocation(location)}
                                className={
                                    activeLocation.name === location.name
                                        ? "active"
                                        : ""
                                }
                            >
                                {location.name}
                            </button>
                        ))}
                    </div>

                    <div className="ContactPage-InfoSection-LocationInfo">

                        <h2>{activeLocation.name}</h2>

                        <div className="ContactPage-InfoSection-LocationInfo-Details">
                            <label className="Navigations">
                                Phone No:
                            </label>

                            <a href={`tel:${activeLocation.phone}`}>
                                {activeLocation.phone}
                            </a>
                        </div>

                        <div className="ContactPage-InfoSection-LocationInfo-Details">
                            <label className="Navigations">
                                Email:
                            </label>

                            <a href={`mailto:${activeLocation.email}`}>
                                {activeLocation.email}
                            </a>
                        </div>

                        <div className="ContactPage-InfoSection-LocationInfo-Details">
                            <label className="Navigations">
                                Address:
                            </label>

                            <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                    activeLocation.address
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {activeLocation.address}
                            </a>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}